import Country from './Country';

export type CategoryId = string;

export type CategoryArray = CategoryId[];

export const Eyewear: CategoryArray = ['84', '85', '86', '180', '181', '182', '239', '240', '241'];
export const shouldDisplayEyewearWarning = (categoryId, countryId) => {
  return Eyewear.includes(categoryId) && countryId.toString() === Country.unitedStates();
};
